import { SET, RESET_STATE } from "@/stores/CommumActionTypes";
import CompaniesService from "@/services/common/CompaniesService";
import { SET_COMPANY_EMAILS } from "../actions/Companies";

const mutations = {
	[SET]: (state, company) =>
	{
		state.company = company;
	},
	[RESET_STATE]: (state) =>
	{
		state.company = CompaniesService.EmptyCompanyFactory();
	},
	[SET_COMPANY_EMAILS]: (state, emails) =>
	{
		state.company.emails = emails;
	}
};

export default { mutations };